import { Link } from "react-router-dom";
import { articles } from "../../../mocks/chigua";

export default function TickerBar() {
  const items = [...articles].slice(0, 8);
  const row = [...items, ...items];
  return (
    <div className="relative flex items-center overflow-hidden bg-primary-600 text-background-50">
      <span className="z-10 flex shrink-0 items-center gap-1.5 bg-primary-700 px-4 py-2.5 text-xs font-bold tracking-wide">
        <i className="ri-chat-smile-2-line" aria-hidden="true" />
        最新瓜速览
      </span>
      <div className="relative flex-1 overflow-hidden">
        <div className="ticker-track flex w-max items-center whitespace-nowrap py-2.5">
          {row.map((a, i) => (
            <Link
              key={`${a.id}-${i}`}
              to={`/baoliao/${a.id}`}
              className="flex items-center gap-2 px-5 text-xs text-background-50/90 hover:text-background-50"
            >
              <span className="h-1 w-1 rounded-full bg-secondary-300" aria-hidden="true" />
              {a.title}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}